import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const BuildCache = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M11.9999 4C7.92032 4 4.55393 7.05369 4.06183 11H2V4.5H4V5.99895C5.82446 3.57065 8.72878 2 11.9999 2C16.4776 2 20.2679 4.94289 21.5421 9H19.4184C18.2316 6.06817 15.3573 4 11.9999 4Z"
      fill="currentColor"
    />
    <path
      d="M19.938 13C19.4459 16.9463 16.0796 20 11.9999 20C8.64256 20 5.76823 17.9318 4.58146 15H2.45774C3.73201 19.0571 7.5223 22 11.9999 22C15.2712 22 18.1755 20.4293 20 18.0009V19.5H22V13H19.938Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M10.9262 6.18328C11.5814 5.76638 12.4186 5.76638 13.0738 6.18328L16.5737 8.41055C17.1506 8.77767 17.5 9.41408 17.5 10.0979V13.9021C17.5 14.5859 17.1506 15.2223 16.5738 15.5894L13.0738 17.8167C12.4186 18.2336 11.5814 18.2336 10.9262 17.8167L7.42625 15.5894C6.84935 15.2223 6.5 14.5859 6.5 13.9021V10.0979C6.5 9.41408 6.84935 8.77767 7.42625 8.41055L10.9262 6.18328ZM12 11.6362L8.87211 9.84886L8.1279 11.1512L11.25 12.9353V16H12.75V12.9353L15.8721 11.1512L15.1279 9.84886L12 11.6362Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default BuildCache;
